// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"290":"9e226e8c260edd23","1231":"4b863a685b149ac7"}[chunkId] + ".css";
};